import React, { useEffect, useRef } from 'react';
import { Tooltip as BootstrapTooltop, Modal } from 'bootstrap';

interface TooltipProps {
  tooltipText: string
}
function Tooltip(props: TooltipProps) {
  const { tooltipText } = props;
  const tooltip = useRef(null);
  useEffect(() => {
    if (tooltip.current) {
      const bootTip = new BootstrapTooltop(tooltip.current);
      bootTip.enable();
    }
  }, [tooltip]);
  return (
    <small
      className="ms-auto"
      ref={tooltip}
      data-bs-toggle="tooltip"
      data-bs-placement="bottom"
      data-bs-container=".quote.container"
      title={tooltipText}
    >
      What&apos;s this?
    </small>
  );
}

export default Tooltip;
